import { useQueryString } from '#hooks/useQueryString';
import { useGetRecordsV2 } from '#pages/DashboardChartForm/api';
import { Divider } from '../styles';
import { ExerciseMedia } from './ExerciseMedia';

export const TotalExerciseMedia = () => {
  const [registedLectureId] = useQueryString(['registered-lecture-id']);

  const { data } = useGetRecordsV2(registedLectureId);

  if (!data) return <div></div>;

  const { recordImages } = data;

  const images = recordImages.filter(image =>
    image.resizedLink.includes('image')
  );

  const videos = recordImages.filter(image =>
    image.resizedLink.includes('video')
  );

  if (images?.length === 0 && videos?.length === 0) return null;

  return (
    <>
      <Divider />
      <ExerciseMedia images={images} videos={videos} />
    </>
  );
};
